import { render } from "./HomePage.vue?vue&type=template&id=261a0312&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=261a0312&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261a0312"],['__file',"src/views/h5/common/home/HomePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "261a0312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('261a0312', __exports__)) {
    api.reload('261a0312', __exports__)
  }
  
  module.hot.accept("./HomePage.vue?vue&type=template&id=261a0312&scoped=true", () => {
    api.rerender('261a0312', render)
  })

}


export default __exports__